<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMUserDataStatusList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.excmuserdatastatus.update.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMUserDataStatusForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMUserDataStatusForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMUserDataStatusForm,
    Loader
  },
  data () {
    return {
      item: {},
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      isLoading: 'excmuserdatastatus/update/isLoading',
      error: 'excmuserdatastatus/update/error',
      deleteError: 'excmuserdatastatus/del/error',
      deleteLoading: 'excmuserdatastatus/del/isLoading',
      created: 'excmuserdatastatus/create/created',
      deleted: 'excmuserdatastatus/del/deleted',
      retrieved: 'excmuserdatastatus/update/retrieved',
      updated: 'excmuserdatastatus/update/updated',
      violations: 'excmuserdatastatus/update/violations'
    })
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }
      this.$router.go(-1)
    },

    updated: function () {
      this.$router.go(-1)
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  methods: {
    ...mapActions({
      createReset: 'excmuserdatastatus/create/reset',
      deleteItem: 'excmuserdatastatus/del/del',
      delReset: 'excmuserdatastatus/del/reset',
      retrieve: 'excmuserdatastatus/update/retrieve',
      updateReset: 'excmuserdatastatus/update/reset',
      update: 'excmuserdatastatus/update/update',
      updateRetrieved: 'excmuserdatastatus/update/updateRetrieved'
    }),
    del () {
      if (window.confirm('Are you sure you want to delete this excmuserdatastatus ?')) {
        this.deleteItem(this.retrieved)
      }
    },
    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },
    onSendForm () {
      this.retrieved.customOrdering = parseInt(this.retrieved.customOrdering)
      this.update(this.retrieved)
    },
    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
